module.exports = __webpack_public_path__ + "static/media/mushroom_mozza_desktop_hero_fr.a0348b0b.jpg";